// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dispute Details */
.dispute-details-page .dashboard-body {
  padding-bottom: 2rem;
}

.dispute-details-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text, #1e293b);
  background: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dispute-details-back:hover {
  opacity: 0.8;
}

.dispute-details-back i {
  margin-right: 0.25rem;
}

.dispute-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.dispute-details-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.dispute-details-card__header {
  margin: 0;
  padding: 0.85rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text, #1e293b);
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
}

.dispute-details-card__header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.25rem;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
}

.dispute-details-card__header-row .dispute-details-card__header {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
}

.dispute-details-chat-badge {
  font-size: 0.8rem;
  font-weight: 600;
  color: #fff;
  background: #0f766e;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
}

.dispute-details-card__body {
  padding: 1.25rem;
}

.dispute-details-card__body--scroll {
  max-height: 380px;
  overflow-y: auto;
}

.dispute-details-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
  font-size: 0.875rem;
}

.dispute-details-row:last-child {
  margin-bottom: 0;
}

.dispute-details-label {
  flex-shrink: 0;
  min-width: 120px;
  color: var(--text-muted, #64748b);
}

.dispute-details-value {
  text-align: right;
  color: var(--text, #1e293b);
}

.dispute-details-value--bold {
  font-weight: 700;
}

.dispute-details-badge {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
}

.dispute-details-badge--dispute {
  background: #fef2f2;
  color: #b91c1c;
}

.dispute-details-badge--by.dispute-details-badge--buyer {
  background: #ccfbf1;
  color: #0f766e;
}

.dispute-details-badge--by.dispute-details-badge--seller {
  background: #fef3c7;
  color: #b45309;
}

.dispute-details-payment-placeholder {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background: #f8fafc;
  color: var(--text-muted, #64748b);
}

.dispute-details-payment-icon {
  font-size: 3rem;
  opacity: 0.6;
}

.dispute-details-payment-text {
  margin: 0;
  font-size: 0.9rem;
}

.dispute-details-chat-body {
  max-height: 320px;
  overflow-y: auto;
}

.dispute-details-chat-empty {
  margin: 0;
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.dispute-details-msg {
  margin-bottom: 1rem;
}

.dispute-details-msg:last-child {
  margin-bottom: 0;
}

.dispute-details-msg--buyer {
  display: flex;
  justify-content: flex-start;
}

.dispute-details-msg--seller {
  display: flex;
  justify-content: flex-end;
}

.dispute-details-msg-bubble {
  max-width: 85%;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.875rem;
}

.dispute-details-msg--buyer .dispute-details-msg-bubble {
  background: #f1f5f9;
  color: var(--text, #1e293b);
}

.dispute-details-msg--seller .dispute-details-msg-bubble {
  background: #e2e8f0;
  color: var(--text, #1e293b);
}

.dispute-details-msg-meta {
  font-size: 0.75rem;
  color: var(--text-muted, #64748b);
  margin-bottom: 0.35rem;
}

.dispute-details-msg-content {
  word-break: break-word;
}

.dispute-details-email-actions {
  margin-bottom: 1.5rem;
}

.dispute-details-email-title {
  margin: 0 0 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text, #1e293b);
}

.dispute-details-email-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.dispute-details-email-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dispute-details-email-btn:hover {
  opacity: 0.9;
}

.dispute-details-email-btn--grey {
  background: #475569;
  color: #fff;
}

.dispute-details-email-btn--yellow {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.dispute-details-resolve-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.dispute-details-resolve-btn {
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.dispute-details-resolve-btn:hover {
  opacity: 0.95;
}

.dispute-details-resolve-btn--cancel {
  background: #dc2626;
  color: #fff;
}

.dispute-details-resolve-btn--favor-buyer {
  background: #16a34a;
  color: #fff;
}

.dispute-details-resolve-btn--favor-seller {
  background: #0f766e;
  color: #fff;
}

@media (max-width: 900px) {
  .dispute-details-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/P2P/DisputeDetailsPage.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Dispute Details */\n.dispute-details-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.dispute-details-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  padding: 0.5rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.dispute-details-back:hover {\n  opacity: 0.8;\n}\n\n.dispute-details-back i {\n  margin-right: 0.25rem;\n}\n\n.dispute-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.dispute-details-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.dispute-details-card__header {\n  margin: 0;\n  padding: 0.85rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text, #1e293b);\n  background: #f1f5f9;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dispute-details-card__header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 1.25rem;\n  background: #f1f5f9;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dispute-details-card__header-row .dispute-details-card__header {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n}\n\n.dispute-details-chat-badge {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #fff;\n  background: #0f766e;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n}\n\n.dispute-details-card__body {\n  padding: 1.25rem;\n}\n\n.dispute-details-card__body--scroll {\n  max-height: 380px;\n  overflow-y: auto;\n}\n\n.dispute-details-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.9rem;\n  font-size: 0.875rem;\n}\n\n.dispute-details-row:last-child {\n  margin-bottom: 0;\n}\n\n.dispute-details-label {\n  flex-shrink: 0;\n  min-width: 120px;\n  color: var(--text-muted, #64748b);\n}\n\n.dispute-details-value {\n  text-align: right;\n  color: var(--text, #1e293b);\n}\n\n.dispute-details-value--bold {\n  font-weight: 700;\n}\n\n.dispute-details-badge {\n  display: inline-block;\n  padding: 0.3rem 0.65rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.dispute-details-badge--dispute {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.dispute-details-badge--by.dispute-details-badge--buyer {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n.dispute-details-badge--by.dispute-details-badge--seller {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.dispute-details-payment-placeholder {\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  background: #f8fafc;\n  color: var(--text-muted, #64748b);\n}\n\n.dispute-details-payment-icon {\n  font-size: 3rem;\n  opacity: 0.6;\n}\n\n.dispute-details-payment-text {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.dispute-details-chat-body {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.dispute-details-chat-empty {\n  margin: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 0.9rem;\n}\n\n.dispute-details-msg {\n  margin-bottom: 1rem;\n}\n\n.dispute-details-msg:last-child {\n  margin-bottom: 0;\n}\n\n.dispute-details-msg--buyer {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.dispute-details-msg--seller {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dispute-details-msg-bubble {\n  max-width: 85%;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.875rem;\n}\n\n.dispute-details-msg--buyer .dispute-details-msg-bubble {\n  background: #f1f5f9;\n  color: var(--text, #1e293b);\n}\n\n.dispute-details-msg--seller .dispute-details-msg-bubble {\n  background: #e2e8f0;\n  color: var(--text, #1e293b);\n}\n\n.dispute-details-msg-meta {\n  font-size: 0.75rem;\n  color: var(--text-muted, #64748b);\n  margin-bottom: 0.35rem;\n}\n\n.dispute-details-msg-content {\n  word-break: break-word;\n}\n\n.dispute-details-email-actions {\n  margin-bottom: 1.5rem;\n}\n\n.dispute-details-email-title {\n  margin: 0 0 0.75rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text, #1e293b);\n}\n\n.dispute-details-email-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.dispute-details-email-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.dispute-details-email-btn:hover {\n  opacity: 0.9;\n}\n\n.dispute-details-email-btn--grey {\n  background: #475569;\n  color: #fff;\n}\n\n.dispute-details-email-btn--yellow {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.dispute-details-resolve-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.dispute-details-resolve-btn {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.dispute-details-resolve-btn:hover {\n  opacity: 0.95;\n}\n\n.dispute-details-resolve-btn--cancel {\n  background: #dc2626;\n  color: #fff;\n}\n\n.dispute-details-resolve-btn--favor-buyer {\n  background: #16a34a;\n  color: #fff;\n}\n\n.dispute-details-resolve-btn--favor-seller {\n  background: #0f766e;\n  color: #fff;\n}\n\n@media (max-width: 900px) {\n  .dispute-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
